export const scrollToStep2 = () => {
    const jobDetailsPage = document.querySelector<HTMLElement>('.page-job-details')
    if (!jobDetailsPage) return

    const step2Header = jobDetailsPage.querySelector<HTMLElement>('.step2-header')
    if (!step2Header) return

    const scroll = () =>
        step2Header.scrollIntoView({ behavior: 'smooth', block: 'start' })

    if (document.readyState === 'complete') {
        requestAnimationFrame(scroll)
    } else {
        window.addEventListener('load', () => requestAnimationFrame(scroll), { once: true })
    }
}
